export const TAXONOMIES = [
  { id: 'anzsrc-2020', name: 'ANZSRC 2020 Fields of Research', levels: 3, nodeCount: 1800 },
  { id: 'openalex-topics', name: 'OpenAlex Topics', levels: 3, nodeCount: 4800 },
  { id: 'isced-f-2013', name: 'ISCED-F 2013', levels: 3, nodeCount: 120 },
  { id: 'cip-2020', name: 'CIP 2020', levels: 3, nodeCount: 2800 },
  { id: 'ddc-summaries', name: 'DDC Summaries', levels: 3, nodeCount: 1100 },
] as const

export const DEFAULT_TAXONOMY = 'anzsrc-2020'
